<template>
    <div class="previewWrapper">
        <div class="slider"
            v-if="previews.length > 0">
            <div :class="[{ isActive: activeId === index },'dot']"
                v-for="(preview, index) in previews"
                :key="index"
                @click="$emit('setActiveId', index)">
                <div class="deleteWrapper">
                    <Button class="deleteButton"
                        v-if="activeId === index"
                        appearance="secondary"
                        prefixIcon="delete"
                        size="tiny"
                        iconSize="s"
                        :iconOnly="true"
                        @click="removeFile(activeId)">
                    </Button>
                </div>
            </div>
            <div :class="[{ isActive: activeId === previews.length },'dot']"
                v-if="previews.length < this.constants.limits.entry.carousel.max"
                @click="$emit('setActiveId', previews.length)">
            </div>
        </div>
        <div class="changePosition"
            v-if="activeId === 0 && coverImageRatio === 'portrait' && previews.length">
            <Button :class="['positionButton', positionButtonActive(position, 'top')]"
                appearance="secondary"
                prefixIcon="vertical_align_top"
                size="tiny"
                iconSize="s"
                :iconOnly="true"
                @click="changePosition('top')">
            </Button>
            <Button :class="['positionButton', positionButtonActive(position, 'center')]"
                appearance="secondary"
                prefixIcon="vertical_align_center"
                size="tiny"
                iconSize="s"
                :iconOnly="true"
                @click="changePosition('center')">
            </Button>
            <Button :class="['positionButton', positionButtonActive(position, 'bottom')]"
                appearance="secondary"
                prefixIcon="vertical_align_bottom"
                size="tiny"
                iconSize="s"
                :iconOnly="true"
                @click="changePosition('bottom')">
            </Button>
        </div>
        <div class="changePosition landscapeCover"
            v-if="activeId === 0 && coverImageRatio === 'landscape' && previews.length">
            <Button :class="['positionButton', positionButtonActive(position, 'left')]"
                appearance="secondary"
                prefixIcon="vertical_align_top"
                size="tiny"
                iconSize="s"
                :iconOnly="true"
                @click="changePosition('left')">
            </Button>
            <Button :class="['positionButton', positionButtonActive(position, 'center')]"
                appearance="secondary"
                prefixIcon="vertical_align_center"
                size="tiny"
                iconSize="s"
                :iconOnly="true"
                @click="changePosition('center')">
            </Button>
            <Button :class="['positionButton', positionButtonActive(position, 'right')]"
                appearance="secondary"
                prefixIcon="vertical_align_bottom"
                size="tiny"
                iconSize="s"
                :iconOnly="true"
                @click="changePosition('right')">
            </Button>
        </div>
        <Button class="arrowIcon toLeft"
            v-if="activeId !== 0"
            size="tiny"
            iconSize="s"
            appearance="secondary"
            prefixIcon="keyboard_arrow_left"
            tabindex="0"
            :iconOnly="true"
            @click="$emit('setActiveId', activeId - 1)">
        </Button>
        <Button class="arrowIcon toRight"
            v-if="(activeId !== previews.length) && previews.length < this.constants.limits.entry.carousel.max"
            size="tiny"
            iconSize="s"
            appearance="secondary"
            prefixIcon="keyboard_arrow_right"
            tabindex="0"
            :iconOnly="true"
            @click="$emit('setActiveId', activeId + 1)">
        </Button>
        <div class="fileSelector"
            v-if="(activeId === previews.length || previews.length === 0) && previews.length < this.constants.limits.entry.carousel.max">
            <input class="fileUploadOriginal"
                accept="image/jpeg"
                type="file"
                name="file"
                id="file"
                tabindex="-1"
                multiple
                @change="uploadFile"/>
            <label class="fileUpload"
                for="file"
                tabindex="0">
                <div class="fileUploadContent">
                    <div class="fileUploadLabel">
                        <Icon class="addFileIcon"
                            icon="add_photo_alternate"/>
                        {{ siteContent.selectImages }}
                    </div>
                </div>
            </label>
        </div>
        <div class="previews"
            v-else>
            <TransitionEffect name="fadeInOut" :appear="true">
                <img :class="['preview', calculatePosition]"
                    :src="previews[activeId]"/>
            </TransitionEffect>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CarouselMedia',
        props: {
            previews: {
                type: Array,
                required: true
            },
            activeId: {
                type: Number,
                required: true
            },
            orientation: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                position: {
                    landscape: 'center',
                    portrait: 'center'
                },
                coverImageRatio: '',
                payload: {
                    files: [],
                    filePaths: []
                },
                currentTime: new Date().getTime(),
            }
        },
        computed: {
            calculatePosition() {
                if(this.activeId === 0) {
                    if(this.orientation === 'landscape') {
                        return this.position.landscape
                    } else if(this.orientation === 'portrait') {
                        return this.position.portrait
                    }
                } else {
                    return 'center'
                }
            }
        },
        methods: {
            async uploadFile(e) {
                var files = e.target.files || e.dataTransfer.files
                if(!files.length) {
                    return
                } else if((e.target.files.length + this.payload.files.length) > this.constants.limits.entry.carousel.max) {
                    this.$toasted.show(this.siteContent.entryImageLimitReached)
                    return
                } else {
                    for(let i = 0; i < e.target.files.length; i++) {
                        await this.createPreview(files[i])
                        var file = files[i]
                        var filePath = 'users/' + this.auth.id + '/entries/' + this.currentTime.toString() + '/' + file.name.replace(/\.[^/.]+$/, "") + '_' + (i + 1)
                        this.payload.files.push(file)
                        this.payload.filePaths.push(filePath)

                        this.$emit('updatePayload', this.payload)
                    }
                }
            },
            removeFile(i) {
                this.previews.splice(i, 1)
                this.payload.files.splice(i, 1)
                this.payload.filePaths.splice(i, 1)

                this.$emit('updatePayload', this.payload)

                if(this.activeId !== 0) {
                    this.$emit('setActiveId', i - 1)
                }

                if(this.activeId === 0) {
                    this.position.landscape = 'center'
                    this.position.portrait  = 'center'
                }
            },
            createPreview(file) {
                var reader = new FileReader()
                reader.readAsDataURL(file)

                reader.onload = (e) => {
                    var image = e.target.result
                    this.previews.push(image)

                    this.$emit('setActiveId', 0)

                    if(this.previews.length === 1) {
                    // only the cover needs to be generated
                        const img = new Image()
                        img.src = image
                        img.onload = () => {
                            if(img.width < img.height) {
                                this.coverImageRatio = 'portrait'
                            } else {
                                this.coverImageRatio = 'landscape'
                            }
                        }
                    }
                }
            },
            positionButtonActive(position, alignment) {
                if(this.orientation === 'portrait') {
                    if(position.portrait === alignment) {
                        return 'positionButtonActive'
                    }
                } else if(this.orientation === 'landscape') {
                    if(position.landscape === alignment) {
                        return 'positionButtonActive'
                    }
                }
            },
            changePosition(pos) {
                if(this.orientation === 'portrait') {
                    this.position.portrait = pos
                } else if(this.orientation === 'landscape') {
                    this.position.landscape = pos
                }
                this.$emit('setPosition', this.position)
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../scss/variables';

    .previewWrapper {
        &:hover {
            .arrowIcon {
                transform: translateY(-50%);
            }

            .deleteWrapper {
                opacity: 1;
                transform: translateX(-50%);
                transition-delay: 0.2s;
            }

            .changePosition {
                opacity: 1;
            }
        }
    }

    .arrowIcon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
    }

    .toRight {
        right: 1rem;
    }

    .toLeft {
        left: 1rem;
    }

    .deleteWrapper {
        position: absolute;
        top: 1rem;
        left: 50%;
        transform: translateX(-50%);
        opacity: 0;

        &:focus {
            opacity: 1;
        }
    }

    .changePosition {
        position: absolute;
        bottom: 1rem;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        z-index: 1;
        opacity: 0;
        transition: $transition-eio-20;
    }

    .positionButton {
        margin-right: 0.5rem;

        &:last-of-type {
            margin: 0;
        }
    }

    .slider {
        position: absolute;
        top: 0.5rem;
        left: 0.5rem;
        right: 0.5rem;
        z-index: 1;
        display: flex;
        justify-content: center;
        margin-bottom: 0.5rem;
    }

    .dot {
        position: relative;
        flex: 1;
        height: 0.2rem;
        background: var(--color-grey-100);
        margin: 0 0.25rem;
        border-radius: 1rem;
        cursor: pointer;
        box-shadow: var(--shadow-s);
        transition: $transition-eio-10;
    }

    .previewWrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .previews {
        position: relative;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;
    }

    .preview {
        width: 100%;
        min-height: 100%;
        object-fit: cover;
    }

    .fileSelector, .fileUpload, .preview {
        height: 28rem;
    }

    .isActive {
        background: var(--color-primary-500);
        cursor: default;
    }

    .fileUpload {
        border-radius: 0;
        width: 100%;
        min-height: 100%;
    }

    .left {
        object-position: left;
    }

    .right {
        object-position: right;
    }

    .top {
        object-position: top;
    }

    .bottom {
        object-position: bottom;
    }

    @media all and (max-width: 960px) {
        .deleteWrapper {
            opacity: 1;
        }

        .changePosition {
            opacity: 1;
        }
    }
</style>

<style lang="scss">
    .landscapeCover {
        .positionButton {
            i {
                transform: rotate(-90deg);
            }
        }
    }

    .positionButtonActive {
        background: var(--color-white-important) !important;
        color: var(--color-black-important) !important;
    }
</style>